function PlanService($q, AppSettings, AuthService, CommonService) {
  'ngInject';

  const service = {};


  // 경기 정보
  service.plans = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/plans2';

    return CommonService.post(url, params);
  };

  // 경기 정보 추가/수정(기본 정보)
  service.setGame = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_game';

    return CommonService.post(url, params);
  };

  // 경기 정보 삭제
  service.removeGame = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/remove_game';

    return CommonService.post(url, params);
  };

  // 경기 정보 입력에 필요한 데이터 조회
  service.getGameMeta = function() {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_game_meta';

    return CommonService.post(url);
  };

  // 상대팀 목록
  service.getTeams = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_teams';

    return CommonService.post(url, params);
  };

  // 경기장 목록
  service.getStadiums = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_stadiums';

    return CommonService.post(url, params);
  };

  // 경기 정보 추가/수정(경기 시작전 정보)
  service.setGameInfo = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_game_info';

    return CommonService.post(url, params);
  };

  // 경기 정보
  service.getGameInfo = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_game_info';

    return CommonService.post(url, params);
  };

  // 경기 출전,대기,교체 선수 입력(개인 플래너에 경기 항목이 나오기 위해서 입력되어야 함)
  service.setEntry = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_entry';

    return CommonService.post(url, params);
  };

  // 경기 출전,대기,교체 선수 목록
  service.getEntry = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_entry';

    return CommonService.post(url, params);
  };

  // 훈련 출전,대기,교체 선수 입력(개인 플래너에 경기 항목이 나오기 위해서 입력되어야 함)
  service.setTrainingEntry = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_training_entry';

    return CommonService.post(url, params);
  };

  // 훈련 출전,대기,교체 선수 목록
  service.getTrainingEntry = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_training_entry';

    return CommonService.post(url, params);
  };

  // 경기 정보 추가/수정(경기 결과 정보)
  service.setGameResult = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_game_result';

    return CommonService.post(url, params);
  };

  // 경기 결과 정보
  service.getGameResult = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_game_result';

    return CommonService.post(url, params);
  };


  // 훈련 생성
  service.setTrainingRoot = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_training_root';

    return CommonService.post(url, params);
  };

  // 훈련 정보 수정
  service.setTraining = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_training';

    return CommonService.post(url, params);
  };

  // 훈련 정보 삭제
  service.removeTraining = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/remove_training';

    return CommonService.post(url, params);
  };

  // 훈련 정보 입력에 필요한 데이터 조회
  service.getTrainingMeta = function() {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_training_meta';

    return CommonService.post(url);
  };

  // 훈련 정보
  service.getTraining = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_training';

    return CommonService.post(url, params);
  };

  // 훈련 참가 예정 선수 입력(개인 플래너에 훈련 항목이 나오기 위해서 설정이 되어야 함)
  service.setTrainingEntry = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_training_entry';

    return CommonService.post(url, params);
  };

  // 스케쥴 정보 생성/수정
  service.setSchedule = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_schedule';

    return CommonService.post(url, params);
  };

  // 스케쥴 삭제
  service.removeSchedule = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/remove_schedule';

    return CommonService.post(url, params);
  };

  // 동영상 생성/수정
  service.setMurl = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/set_murl';

    return CommonService.post(url, params);
  };

  // 동영상 목록
  service.getMurls = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_murls';

    return CommonService.post(url, params);
  };

  // 동영상 삭제
  service.removeMurl = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/remove_murl';

    return CommonService.post(url, params);
  };

  // 경기 명칭 목록
  service.getGnames = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'plan/get_gnames';

    return CommonService.post(url, params);
  };

  // 지오코딩
  service.geocode = function(address) {
    address = address.replace(/\s/g, '');   // google maps geocode API 요청시 400 Bad Request 응답이 나오지 않게 하기 위해 공백을 '' 로 변경
    const url = AppSettings.apiUrl.geocode + address;

    return CommonService.get(url);
  };

  // 위경도를 기상청 grid x,y 로 변경 - http://werty.co.kr/blog/3011
  // LCC DFS 좌표변환 ( code : "toXY"(위경도->좌표, v1:위도, v2:경도), "toLL"(좌표->위경도,v1:x, v2:y) )
  service.dfsXyConv = function(code, v1, v2) {
    // LCC DFS 좌표변환을 위한 기초 자료
    //
    var RE = 6371.00877; // 지구 반경(km)
    var GRID = 5.0; // 격자 간격(km)
    var SLAT1 = 30.0; // 투영 위도1(degree)
    var SLAT2 = 60.0; // 투영 위도2(degree)
    var OLON = 126.0; // 기준점 경도(degree)
    var OLAT = 38.0; // 기준점 위도(degree)
    var XO = 43; // 기준점 X좌표(GRID)
    var YO = 136; // 기1준점 Y좌표(GRID)

    var DEGRAD = Math.PI / 180.0;
    var RADDEG = 180.0 / Math.PI;

    var re = RE / GRID;
    var slat1 = SLAT1 * DEGRAD;
    var slat2 = SLAT2 * DEGRAD;
    var olon = OLON * DEGRAD;
    var olat = OLAT * DEGRAD;

    var sn = Math.tan(Math.PI * 0.25 + slat2 * 0.5) / Math.tan(Math.PI * 0.25 + slat1 * 0.5);
    sn = Math.log(Math.cos(slat1) / Math.cos(slat2)) / Math.log(sn);
    var sf = Math.tan(Math.PI * 0.25 + slat1 * 0.5);
    sf = Math.pow(sf, sn) * Math.cos(slat1) / sn;
    var ro = Math.tan(Math.PI * 0.25 + olat * 0.5);
    ro = re * sf / Math.pow(ro, sn);
    var rs = {};
    if (code == "toXY") {

      rs['lat'] = v1;
      rs['lng'] = v2;
      var ra = Math.tan(Math.PI * 0.25 + (v1) * DEGRAD * 0.5);
      ra = re * sf / Math.pow(ra, sn);
      var theta = v2 * DEGRAD - olon;
      if (theta > Math.PI) theta -= 2.0 * Math.PI;
      if (theta < -Math.PI) theta += 2.0 * Math.PI;
      theta *= sn;
      rs['nx'] = Math.floor(ra * Math.sin(theta) + XO + 0.5);
      rs['ny'] = Math.floor(ro - ra * Math.cos(theta) + YO + 0.5);
    }
    else {
      rs['nx'] = v1;
      rs['ny'] = v2;
      var xn = v1 - XO;
      var yn = ro - v2 + YO;
      ra = Math.sqrt(xn * xn + yn * yn);
      if (sn < 0.0) - ra;
      var alat = Math.pow((re * sf / ra), (1.0 / sn));
      alat = 2.0 * Math.atan(alat) - Math.PI * 0.5;

      if (Math.abs(xn) <= 0.0) {
        theta = 0.0;
      }
      else {
        if (Math.abs(yn) <= 0.0) {
          theta = Math.PI * 0.5;
          if (xn < 0.0) - theta;
        }
        else theta = Math.atan2(xn, yn);
      }
      var alon = theta / sn + olon;
      rs['lat'] = alat * RADDEG;
      rs['lng'] = alon * RADDEG;
    }
    return rs;
  };

  // 날씨 데이터 받기
  service.getWeather = function(nx, ny) {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1;
    var yyyy = today.getFullYear();
    var hours = today.getHours();
    var minutes = today.getMinutes();

    if(minutes < 30){
      // 30분보다 작으면 한시간 전 값
      hours = hours - 1;
      if(hours < 0){
        // 자정 이전은 전날로 계산
        today.setDate(today.getDate() - 1);
        dd = today.getDate();
        mm = today.getMonth()+1;
        yyyy = today.getFullYear();
        hours = 23;
      }
    }
    if(hours<10) {
      hours='0'+hours
    }
    if(mm<10) {
      mm='0'+mm
    }
    if(dd<10) {
      dd='0'+dd
    }

    var _nx = nx,
      _ny = ny,
      apikey = AppSettings.apiKey.kma,
      today = yyyy+""+mm+""+dd,
      basetime = hours + "00",
      fileName = AppSettings.apiUrl.kmaWeather;
    fileName += "?ServiceKey=" + apikey;
    fileName += "&base_date=" + today;
    fileName += "&base_time=" + basetime;
    fileName += "&nx=" + _nx + "&ny=" + _ny;
    fileName += "&pageNo=1&numOfRows=10";
    fileName += "&_type=json";

    return CommonService.proxyGet(fileName);
  };

  // 미세먼지 조회 서비스 개발
  // data.go.kr 에서 제공하는 한국환경공단 국가대기오염정보 활용
  // 일 트래픽이 100건 까지만 지원되기 때문에 서버에서 30분에 한번 정도 호출하고 결과값을 DB 에 저장해놓고 그 데이터를 불러올 수 있는 API 를 만드는 방식으로 진행 필요
  // 먼저 클라이언트에서 구현한 후 서버에 예시로 제공
  // 미세먼지 데이터를 얻는 방법은 먼저 측정소를 구한 다음 그 측정소의 미세먼지 데이터를 받아와야 함
  // 우리는 운동장 명칭만 가지고 있기 때문에 아래와 같은 방법을 사용
  // (1) 운동장 명칭으로 google geocoding 을 사용해서 위경도 좌표를 구함 (날씨 정보를 가져올 때와 같음)
  // (2) 위경도 좌표를 TM 좌표로 변경한 다음 그 TM 좌표로 측정소 정보를 가져옴 (미세먼지 API 에서 getNearbyMsrstnList 오퍼레이션 사용)
  //    => 좌표 변환에는 네이버 API https://navermaps.github.io/maps.js/docs/tutorial-1-geocoder-transcoord.example.html 사용해야 할 것 같음
  // (3) 측정소 정보를 가지고 getMsrstnAcctoRltmMesureDnsty 오퍼레이션을 사용해서 해당 측정소의 미세먼지 데이터를 받음
  // 참고 : 16개 시도에 대한 대표 좌표
  // 강원 - 264736.470517, 486878.385337
  // 경기 - 199662.909713, 417418.343812
  // 경남 - 352999.552842, 193890.827902
  // 경북 - 331909.98907, 346089.868309
  // 광주 - 185515.813623, 183803.918249
  // 대구 - 344756.656486, 264748.285538
  // 대전 - 235084.282223, 316093.559702
  // 부산 - 390236.078844, 188608.429949
  // 서울 - 198170.875872, 451309.989888
  // 울산 - 410962.771285, 228882.867373
  // 인천 - 174022.784741, 440435.408342
  // 전남 - 148582.233957, 146016.732845
  // 전북 - 210396.189718, 259140.750861
  // 제주 - 152049.0201, -5200.708962
  // 충남 - 175808.029101, 345251.442257
  // 충북 - 242984.131368, 347203.717629
  service.getFineDust = function(sidoNm) {
    let url = 'http://openapi.airkorea.or.kr/openapi/services/rest/ArpltnInforInqireSvc/getCtprvnRltmMesureDnsty?sidoName=' + sidoNm + '&pageNo=1&numOfRows=1&ver=1.3&_returnType=json&ServiceKey=' + AppSettings.apiKey.fineDust;

    return CommonService.proxyGet(url);
  };

  // 유튜브 영상 추천 조회
  // service.getVideoRecommend = function() {
  //   let url = 'https://content.googleapis.com/youtube/v3/search?maxResults=10&part=snippet&q=football%20training%20%EB%B3%BC&key=AIzaSyD0InW9sj-fz24ZctoXQa9KaRqXvxi-QSI';

  //   return CommonService.proxyGet(url);
  // };
  service.getVideoRecommend = function(params) {
    let url = 'https://content.googleapis.com/youtube/v3/search?maxResults=' + params.maxResults + '&part=' + params.part + '&q=' + encodeURIComponent(params.q) + '&key=' + AppSettings.apiKey.youtube;

    return CommonService.proxyGet(url);
  };

  return service;

}

export default {
  name: 'PlanService',
  fn: PlanService
};
